import { AgTechActionButton } from "@agtech/web/components/Buttons/AgTechButtons";
import AgTechGrid from "@agtech/web/components/Grids/AgTechGrid";
import { AgTechMoneyFormatter } from "@agtech/web/utilities/AgTechUtilities";
import { Payment, PaymentTypes } from "@sales/data/invoicing/payments/InvoicePaymentData";
import PaymentsActionMenu from "../menus/PaymentsActionMenu";
import { AgTechIndex } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechContact, getContactFullName } from "@agtech/data/contacts/ContactData";
import { gridItems } from "@agtech/web/components/Grids/Data/AgTechGridProps";
import AddPaymentDialog from "../../dialogs/payments/InvoiceAddPaymentDialog";
import AgTechGridLink from "@agtech/web/components/Grids/Controls/AgTechGridLink";
import SaleContactDetailDialog from "../../../contacts/dialogs/SaleContactDetailDialog";

export type InvoicePaymentsViewGridProps = {
    invoiceId: number,
    payments: Payment[],
    contacts: AgTechIndex<AgTechContact>,
    addActions?: boolean,
    showHeader?: boolean
}

const InvoicePaymentsGrid = (props: InvoicePaymentsViewGridProps) => {
    return (
        <AgTechGrid
            header={props.showHeader ?{
                title: 'Payments',
                content: () => (
                    <div className='column-based horizontal-pane container'>
                        <AddPaymentDialog.Button
                            invoiceId={props.invoiceId}
                            classes="button-highlight"
                        />
                    </div>
                )
            } : undefined}
            data={{
                itemQuery: gridItems(props.payments)
            }}
            columns={[
                {
                    header: 'Amount',
                    value: p => AgTechMoneyFormatter.format(p.amount)
                },
                {
                    header: 'Payment Type',
                    value: p => PaymentTypes.find(pm => pm.id === p.paymentType)?.description ?? ''
                },
                {
                    header: 'Payer',
                    value: p => (
                        <AgTechGridLink
                            content={getContactFullName(props.contacts[p.payerId])}
                            onClick={e => SaleContactDetailDialog.Open(e, {
                                contactId: p.payerId
                            })}
                        />
                    )
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return false;
            }}
            noRecordsConfig={{
                message: 'There are currently no payments on the invoice.',
                action: {
                    prompt: 'To create one, please click the button below',
                    button: () => (
                        <AddPaymentDialog.Button
                            invoiceId={props.invoiceId}
                            classes="button-highlight"
                        />
                    )
                }
            }}
            actions={props.addActions ? {
                rendering: payment => (
                    <AgTechActionButton classes='stretched centered container'>
                        <PaymentsActionMenu payment={payment}/>
                    </AgTechActionButton>
                )
            } : undefined}
        />
    )
}

export default InvoicePaymentsGrid;